import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageTop10Origen.css';

function formatNumber(n) {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

function formatCompact(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(0) + 'K';
  return n.toString();
}

const DOM_TOTAL = 278372312;
const TRANS_TOTAL = 133818689;

const DOM_DATA = [
  { pos: 1,  anunciante: 'GRUPO INTUR',              inv: 27378923, spots: 140103, inv6y: [27378923,27610628,20955844,18713130,18410852,15360430] },
  { pos: 2,  anunciante: 'LOTELHSA',                  inv: 14254912, spots: 64165,  inv6y: [14254912,3783177,2296891,2153931,2419709,3243840] },
  { pos: 3,  anunciante: 'GRUPO CONTINENTAL',          inv: 11587643, spots: 94756,  inv6y: [11587643,7817810,8114851,3620171,3534754,3636204] },
  { pos: 4,  anunciante: 'CORPORACION DINANT',         inv: 11431336, spots: 55427,  inv6y: [11431336,10142600,6330215,2895317,2716756,2755090] },
  { pos: 5,  anunciante: 'BANCO ATLANTIDA',            inv: 9569949,  spots: 206898, inv6y: [9569949,8846003,11299656,11941465,11879686,13401456] },
  { pos: 6,  anunciante: 'SUPERMERCADOS LA COLONIA',   inv: 8442330,  spots: 116127, inv6y: [8442330,9609275,8138251,4880194,5355640,5227741] },
  { pos: 7,  anunciante: 'GRUPO FINANCIERO FICOHSA',   inv: 7584324,  spots: 139962, inv6y: [7584324,11821741,8430215,8986975,8399230,7382853] },
  { pos: 8,  anunciante: 'DIUNSA',                     inv: 5759164,  spots: 23254,  inv6y: [5759164,5886366,4555320,4428123,4178747,2638413] },
  { pos: 9,  anunciante: 'BANPAIS',                    inv: 5419744,  spots: 90118,  inv6y: [5419744,7094674,7068525,4622643,2618379,2130423] },
  { pos: 10, anunciante: 'CARRION',                    inv: 5099846,  spots: 14313,  inv6y: [5099846,6361860,2292218,245939,440,0] },
];

const TRANS_DATA = [
  { pos: 1,  anunciante: 'SERCOM DE HONDURAS',  inv: 15760524, spots: 188454, inv6y: [15760524,16612513,13004506,11794723,10211931,9065004] },
  { pos: 2,  anunciante: 'CELTEL',              inv: 12871995, spots: 107273, inv6y: [12871995,10779385,9465206,10823517,10878041,7984719] },
  { pos: 3,  anunciante: 'GENOMMA LAB',         inv: 12781686, spots: 16045,  inv6y: [12781686,10729768,9081975,16166563,17716525,23397402] },
  { pos: 4,  anunciante: 'BAC CREDOMATIC',      inv: 10869232, spots: 163043, inv6y: [10869232,8836098,7125731,7823520,2428174,3337276] },
  { pos: 5,  anunciante: 'GRUPO SALINAS',       inv: 5362913,  spots: 66656,  inv6y: [5362913,3224186,3939919,7705940,5535267,7824874] },
  { pos: 6,  anunciante: 'UNICOMER',            inv: 5037232,  spots: 24109,  inv6y: [5037232,4895129,3973956,2461548,969049,743885] },
  { pos: 7,  anunciante: 'FARMAMEDICA',         inv: 4649681,  spots: 14003,  inv6y: [4649681,5322415,4178924,5494693,4576608,2821389] },
  { pos: 8,  anunciante: 'NESTLE',              inv: 3636819,  spots: 25713,  inv6y: [3636819,1791090,2530276,2919903,4831737,6114010] },
  { pos: 9,  anunciante: 'COLGATE PALMOLIVE',   inv: 3537840,  spots: 17795,  inv6y: [3537840,3733478,3348181,2637365,2233102,3424853] },
  { pos: 10, anunciante: 'HONDUBET',            inv: 3312709,  spots: 29159,  inv6y: [3312709,2089380,696572,0,0,0] },
];

function Sparkline({ inv6y }) {
  const chronological = [...inv6y].reverse();
  const inv2025 = inv6y[0];
  const inv2020 = inv6y[5];
  const isUp = inv2025 >= inv2020;
  const color = isUp ? '#4ade80' : '#f87171';

  const w = 100;
  const h = 32;
  const padX = 3;
  const padY = 4;

  const max = Math.max(...chronological);
  const min = Math.min(...chronological);
  const range = max - min || 1;

  const points = chronological.map((val, i) => {
    const x = padX + (i / (chronological.length - 1)) * (w - padX * 2);
    const y = padY + (1 - (val - min) / range) * (h - padY * 2);
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const firstX = padX;
  const lastX = padX + (w - padX * 2);
  const areaPoints = `${firstX},${h - padY} ${polyline} ${lastX},${h - padY}`;

  const pctChange = inv2020 > 0
    ? ((inv2025 - inv2020) / inv2020 * 100).toFixed(0)
    : null;

  return (
    <div className="spark-wrap">
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <defs>
          <linearGradient id={`sg-${isUp ? 'u' : 'd'}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.25" />
            <stop offset="100%" stopColor={color} stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <polygon points={areaPoints} fill={`url(#sg-${isUp ? 'u' : 'd'})`} />
        <polyline points={polyline} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        {(() => {
          const lp = points[points.length - 1].split(',');
          return <circle cx={lp[0]} cy={lp[1]} r="2" fill={color} />;
        })()}
      </svg>
      <span className={`spark-pct ${isUp ? 'spark-up' : 'spark-down'}`}>
        {pctChange !== null ? (isUp ? '+' : '') + pctChange + '%' : 'NEW'}
      </span>
    </div>
  );
}

function MiniTable({ title, subtitle, data, total, accentColor }) {
  const maxInv = data[0].inv;
  let cumPct = 0;

  return (
    <div className="mini-table-block">
      <div className="mini-table-header">
        <h2 className="mini-table-title" style={{ color: accentColor }}>{title}</h2>
        <p className="mini-table-subtitle">{subtitle} &middot; ${formatNumber(total)}</p>
      </div>
      <table className="mini-table">
        <thead>
          <tr>
            <th className="mt-pos">#</th>
            <th className="mt-name">Anunciante</th>
            <th className="mt-inv">Valor Mercado</th>
            <th className="mt-pct">%</th>
            <th className="mt-spots">Spots</th>
            <th className="mt-spark">Inv. 6Y</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => {
            const pct = (row.inv / total) * 100;
            cumPct += pct;
            return (
              <tr key={row.pos} className="mt-row" style={{ animationDelay: `${idx * 0.04}s` }}>
                <td className="mt-pos">
                  <span className={`mt-pos-badge ${row.pos <= 3 ? 'mt-pos-top3' : ''}`} style={row.pos <= 3 ? { borderColor: accentColor, boxShadow: `0 0 8px ${accentColor}30` } : {}}>
                    {row.pos}
                  </span>
                </td>
                <td className="mt-name">
                  <span className="mt-adv-name">{row.anunciante}</span>
                  <div className="mt-bar-bg">
                    <div className="mt-bar" style={{ width: `${(row.inv / maxInv) * 100}%`, background: accentColor }}></div>
                  </div>
                </td>
                <td className="mt-inv">${formatNumber(row.inv)}</td>
                <td className="mt-pct">{pct.toFixed(2)}%</td>
                <td className="mt-spots">{formatNumber(row.spots)}</td>
                <td className="mt-spark"><Sparkline inv6y={row.inv6y} /></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function PageTop10Origen() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="top10-page">
        <header className="top10-header">
          <button className="btn-back" onClick={() => navigate('/industria-anio-gobierno')}>
            &#8592; Gobierno
          </button>
          <div className="top10-title-block">
            <h1 className="top10-title">Top 10 por Origen</h1>
            <p className="top10-subtitle">Dom&eacute;stico vs Transnacional &middot; Honduras 2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/top-10-gobierno')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <div className="top10-tables">
          <MiniTable
            title="Dom&eacute;stico"
            subtitle="Top 10 Capital Nacional"
            data={DOM_DATA}
            total={DOM_TOTAL}
            accentColor="#4ade80"
          />
          <MiniTable
            title="Transnacional"
            subtitle="Top 10 Capital Extranjero"
            data={TRANS_DATA}
            total={TRANS_TOTAL}
            accentColor="#93c5fd"
          />
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageTop10Origen;
